import { getTreatments, initSplitSdk } from '@splitsoftware/splitio-redux';
import { Dispatch } from 'redux';
import { CheckoutState } from '../state';
import { AppNamespace } from '../state/app';
import { getSplitioClient } from '../utils/splitio';

export const initializeSplitioSdk = (initialData: AppNamespace) => async (
    dispatch: Dispatch<CheckoutState>,
) => {
    const {
        isProd,
        splitIOProdKey,
        event: { id },
    } = initialData;

    dispatch(
        initSplitSdk({
            config: getSplitioClient(id, isProd ? splitIOProdKey : null),
        }),
    );
};

export const getSplitioTreatments = (ffNames: string[]) => async (
    dispatch: Dispatch<CheckoutState>,
    getState: () => CheckoutState,
) => {
    const {
        app: { event },
    } = getState();

    dispatch(
        getTreatments({
            splitNames: ffNames,
            attributes: { eventId: event?.id },
        }) as any,
    );
};
